import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { memo } from 'react';
import type { FuseNavBadgeType } from './types/FuseNavBadgeType';

const Root = styled('div')(({ theme }) => ({
	padding: '0',
	fontSize: 12,
	fontWeight: 400,
	width: 28,
	height: 28,
	borderRadius: '100px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: theme.palette.secondary.main,
	color: theme.palette.secondary.contrastText,
	marginLeft: '8px',
	flexShrink: 0,
}));

type FuseNavBadgeProps = {
	className?: string;
	classes?: string;
	badge: FuseNavBadgeType;
};

/**
 * FuseNavBadge component.
 * This component will render a badge on a FuseNav element. It accepts a `FuseNavBadgeType` as a prop,
 * which is an object containing a title and background and foreground colour.
 */
function FuseNavBadge(props: FuseNavBadgeProps) {
	const { className = '', classes = '', badge } = props;

	return (
		<Root
			className={clsx('item-badge', className, classes)}
			style={{
				backgroundColor: badge.bg,
				color: badge.fg,
			}}
		>
			{badge.title}
		</Root>
	);
}

export default memo(FuseNavBadge);
